$(function() {
	//searchSlick
    $('.searchSlick--lifestyle').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive:  [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
         }],
    });
    $('.searchSlick--brandPageNav').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive:  [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
         }],
    });
    $('.searchSlick--customize').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive:  [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
         }],
    });
    
    $('.searchSlick--featured').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive:  [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
         }],
    });
    //products__stickyNav--list
    $('.products__stickyNav--list > li > dl > dt .plus').on({'click':function(){
		$(this).parent('dt').toggleClass('selected');
		$(this).parent('dt').next('dd').slideToggle(300);
		return false;
		}
	});
});